/**
 * Author:hong.rong
 * Desc: 加载联邦组件 // todo: 使用前在_documents.tsx文件先加载remoteEntry.js
 * Date:2022-10-14
 */

// import * as React from 'react'
// import { importRemote } from './utils'

// const { useState, useEffect } = React

// type MFComponentProps = {
//   loader?: JSX.Element | null
//   url: string
//   scope: string
//   module: string
//   params?: Record<string, any>
// }

// const MFComponent = ({ loader, url, scope, module, params = {} }: MFComponentProps) => {
//   const [Comp, setComp] = useState(null)

//   useEffect(() => {
//     if (url) {
//       setComp(React.lazy(() => importRemote({ url, scope, module })))
//     }
//   }, [url])

//   if (!url || !scope || !module || !Comp) {
//     return loader || <div />
//   }

//   // 动态加载
//   // const Component = React.lazy(() => importRemote({ url: remoteUrl, scope, module }))

//   return <React.Suspense fallback={loader || ''}>{Comp && <Comp {...params} />}</React.Suspense>
// }

// export default MFComponent
import dynamic from 'next/dynamic';
const PURender = dynamic(() => import('./PURender'), { ssr: false });

export default PURender;
